import {API} from 'aws-amplify';

export const read = async () => API.get('eventmanagerAdminApi', '/trainings', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/trainings/${id}`, {});

export const removeGuest = async (id, trainingGuestId) =>
  API.del('eventmanagerAdminApi', `/trainings/${id}/guests/${trainingGuestId}`, {});

export const addGuests = async (id, guests) =>
  API.put('eventmanagerAdminApi', `/trainings/${id}/guests`, {body: {guests}});

export const readGuests = async (id) => API.get('eventmanagerAdminApi', `/trainings/${id}/guests`, {});

export const readTemplates = async (id) => API.get('eventmanagerAdminApi', `/trainings/${id}/templates`, {});

export const createTemplate = async (id, template) => API.put('eventmanagerAdminApi', `/trainings/${id}/templates`,
  {body: template});

export const updateTemplate = async (id, template) => API.post('eventmanagerAdminApi', `/trainings/${id}/templates`,
  {body: template});

export const removeTemplate = async (template) =>
  API.del('eventmanagerAdminApi', `/trainings/${template.trainingId}/templates/${template.id}`, {});

export const update = async (training) => API.post('eventmanagerAdminApi', `/trainings`, {body: training});

export const create = async (training) => API.put('eventmanagerAdminApi', `/trainings`, {body: training});

export const del = async (id) => API.del('eventmanagerAdminApi', `/trainings/${id}`, {});


export const sendAllGuestsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/trainings/${id}/mail/${templateId}/all`, {});

export const sendConfirmedGuestsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/trainings/${id}/mail/${templateId}/confirmed`, {});

export const sendPendingGuestsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/trainings/${id}/mail/${templateId}/pending`, {});

export const sendTestMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/trainings/${id}/mail/${templateId}/test`, {});

export const updateCeo = (trainingId, ceoId, capacity) =>
  API.post('eventmanagerAdminApi', `/trainings/${trainingId}/ceo/${ceoId}`, { body: { capacity } });

export const sendMail = (trainingId, templateId, ceos) =>
  API.post('eventmanagerAdminApi', `/trainings/mail/${trainingId}/template/${templateId}`, { body: { ceos } });
